import rootReducer from "./Reducer/index.ts";
// import { createStore } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import sessionStorage from "redux-persist/es/storage/session";


const persistConfig = {
  key: 'root',
  storage: sessionStorage,
  whitelist: ["client","date", "region", "status", "pagination", "entity", "orphanPagination","VenueStatusPagination","StaffMemberUseCasePagination"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
  
  // Type exports
  export type RootState = ReturnType<typeof store.getState>;
  export type AppDispatch = typeof store.dispatch;
  
  export default store;